import { render } from "./B2bFiltersCentres.vue?vue&type=template&id=37d6679c&scoped=true&lang=pug"
import script from "./B2bFiltersCentres.vue?vue&type=script&lang=js"
export * from "./B2bFiltersCentres.vue?vue&type=script&lang=js"

import "./B2bFiltersCentres.vue?vue&type=style&index=0&id=37d6679c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d6679c"]])

export default __exports__